import Box from "ds/components/Box";
import TableHeadColumn from "ds/components/Table/Head/Column";
import TableHeadColumnTitle from "ds/components/Table/Head/Column/Title";
import useColumnSort from "ds/components/Table/Head/Column/useColumnSort";
import { TableColumnMeta } from "ds/components/Table/types";

type EnvironmentTableColumnProps = {
  column: TableColumnMeta;
  tableId: string;
};

const EnvironmentTableColumn = ({ column, tableId }: EnvironmentTableColumnProps) => {
  const { ariaSort, handleSort, icon } = useColumnSort(column.id, tableId);

  return (
    <TableHeadColumn
      key={`thead-column-${column.id}`}
      column={column}
      stickyRight={column.id === "actions"}
      ariaSort={ariaSort}
    >
      <Box fullHeight align="center">
        <TableHeadColumnTitle
          title={column.noHeader ? "" : column.title}
          onSort={handleSort}
          sortIcon={icon}
          allowsSorting={column.allowsSorting}
        />
      </Box>
    </TableHeadColumn>
  );
};

export default EnvironmentTableColumn;
